import { api } from './api.service';
import { ScheduleCancelReason } from '../entities/ScheduleCancel';

export const scheduleCancel = api.injectEndpoints({
  endpoints: build => ({
    cancelSchedule: build.mutation<void, { id: string; chatSessionId: string; token: string }>({
      query: ({ id, chatSessionId, token }) => ({
        url: `/portal/v1/schedule/cancel/${id}`,
        method: 'PUT',
        body: { chatSessionId },
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    }),

    cancelScheduleReason: build.mutation<void, { id: string; reason: ScheduleCancelReason; token: string }>({
      query: ({ id, reason, token }) => ({
        url: `/portal/v1/schedule/cancelReason/${id}`,
        method: 'PUT',
        body: { reason },
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    })
  })
});

export const { useCancelScheduleMutation, useCancelScheduleReasonMutation } = scheduleCancel;
